import Vue from "vue";
import App from "./app.vue";
import iView from "iview";
import "./themes/index.less";
import locale from "iview/dist/locale/en-US";
import Embed from "v-video-embed";

import { router } from "./router/index";
import "famfamfam-flags/dist/sprite/famfamfam-flags.css";
import "./theme.less";
import Ajax from "./lib/ajax";
import Util from "./lib/util";
import SignalRAspNetCoreHelper from "./lib/SignalRAspNetCoreHelper";

Vue.use(iView, { locale });
import store from "./store/index";
Vue.config.productionTip = false;
import { appRouters, otherRouters } from "./router/router";
if (!abp.utils.getCookieValue("Abp.Localization.CultureName")) {
  let language: string = navigator.language;
  abp.utils.setCookieValue("Abp.Localization.CultureName", language, new Date(new Date().getTime() + 5 * 365 * 86400000), abp.appPath);
}

Vue.use(Embed);

Ajax.get("/AbpUserConfiguration/GetAll")
  .then(data => {
    Util.abp = Util.extend(true, Util.abp, data.data.result);
    new Vue({
      render: h => h(App),
      router: router,
      store: store,
      data: {
        currentPageName: ""
      },
      async mounted() {
        this.currentPageName = this.$route.name as string;
        await this.$store.dispatch({
          type: "session/init"
        });

        if (!!this.$store.state.session.user && this.$store.state.session.application.features["SignalR"]) {
          if (this.$store.state.session.application.features["SignalR.AspNetCore"]) {
            SignalRAspNetCoreHelper.initSignalR();
          }
        }

        this.$store.commit("app/initCachepage");
        this.$store.commit("app/updateMenulist");
      },
      created() {}
    }).$mount("#app");
  })
  .catch(error => {
    Util.abp.auth.clearToken();
    location.reload();
  });
